const base_url = 'https://adminfootball.gamewins.co.za/api/upload'
export {base_url}

const fetchContent = `${base_url}/fetchContent`
export {fetchContent}

const deleteGoalAlertQuiz = `${base_url}/deleteGoalAlertTriviaContent`
export {deleteGoalAlertQuiz}

const deleteGoalAlertNews = `${base_url}/deletegoalcontent`
export {deleteGoalAlertNews}

const deleteFootballQuiz = `${base_url}/deletefootballquizcontent`
export {deleteFootballQuiz}


const footballQuizUpload = `${base_url}/content-upload/QUIZ`
export {footballQuizUpload}

const GoalAlertTriviaQuizUpload = `${base_url}/content-upload/GoalAlertTriviaQuiz`
export {GoalAlertTriviaQuizUpload}

const GoalAlertNewsUpload = `${base_url}/content-upload/NEWS`
export {GoalAlertNewsUpload}